'use client'

import { useState } from 'react'
import BlogRedesign from './_blocks/Main_redesign/Blog'
import Contact from './_blocks/Main_redesign/Contact'
import About from './_blocks/Main_redesign/About'
import CtaBanner from './_blocks/Main_redesign/CtaBanner'
import Hero from './_blocks/Main_redesign/Hero'
import Portfolio from './_blocks/Main_redesign/Portfolio'
import Services from './_blocks/Main_redesign/Services'
import ItProduct from './_blocks/Main_redesign/ItProduct'
import TextDivider from './_blocks/Main_redesign/TextDivider'
import AnimatedSection from '@/components/AnimatedSection'
import { useModal } from '@/blocks/redesign_blocks/Modal/ModalContext'
import styles from './page.module.css'

export default function Home() {
	const { openConsultationModal } = useModal()

	const openTextDividerModal = () => {
		openConsultationModal()
	}

	return (
		<>
			<main className={styles.main}>
				<AnimatedSection animation="slideUp">
				<Hero onConsultationClick={openConsultationModal} />
				</AnimatedSection>
				<AnimatedSection animation="slideUp">
					<TextDivider onConsultationClick={openTextDividerModal} />
				</AnimatedSection>
				<AnimatedSection animation="slideUp">
					<Services />
				</AnimatedSection>
				<AnimatedSection animation="slideUp">
					<div className={styles.itProductBlock}>
						<ItProduct />
					</div>
				</AnimatedSection>
				<AnimatedSection animation="slideUp">
					<Portfolio />
				</AnimatedSection>
			</main>
			
			<AnimatedSection animation="fadeIn">
				<CtaBanner onConsultationClick={openConsultationModal} />
			</AnimatedSection>
			
			<main className={styles.main}>
				<AnimatedSection animation="slideUp">
					<About />
				</AnimatedSection>
				<AnimatedSection animation="slideUp">
					<BlogRedesign />
				</AnimatedSection>
			</main>
			
			<AnimatedSection animation="fadeIn">
				<Contact />
			</AnimatedSection>
		</>
	)
}
